module.exports = __webpack_public_path__ + "img/Rectangle19header.af41465a.svg";